/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type StageEntityTypeEnum = "containers" | "shipments" | "%future added value";
export type infoUnpickEntityStageInput = {
    clientMutationId?: string | null;
    entityType: StageEntityTypeEnum;
    entitySlug: string;
    stage?: string | null;
};
export type ContainerWorkflowUnpickStageMutationVariables = {
    input: infoUnpickEntityStageInput;
};
export type ContainerWorkflowUnpickStageMutationResponse = {
    readonly infoUnpickEntityStage: {
        readonly clientMutationId: string | null;
    } | null;
};
export type ContainerWorkflowUnpickStageMutation = {
    readonly response: ContainerWorkflowUnpickStageMutationResponse;
    readonly variables: ContainerWorkflowUnpickStageMutationVariables;
};



/*
mutation ContainerWorkflowUnpickStageMutation(
  $input: infoUnpickEntityStageInput!
) {
  infoUnpickEntityStage(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoUnpickEntityStagePayload",
    "kind": "LinkedField",
    "name": "infoUnpickEntityStage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContainerWorkflowUnpickStageMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContainerWorkflowUnpickStageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "089f9fd07a7ee54ee8b4f388198759f1",
    "id": null,
    "metadata": {},
    "name": "ContainerWorkflowUnpickStageMutation",
    "operationKind": "mutation",
    "text": "mutation ContainerWorkflowUnpickStageMutation(\n  $input: infoUnpickEntityStageInput!\n) {\n  infoUnpickEntityStage(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'e481feac1493d036306dd5bb520a7834';
export default node;
